import {
  GET_PAYMENT_STATISTICS_FAILURE,
  GET_PAYMENT_STATISTICS_REQUEST,
  GET_PAYMENT_STATISTICS_RESET,
  GET_PAYMENT_STATISTICS_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const getPaymentStatisticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case GET_PAYMENT_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case GET_PAYMENT_STATISTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case GET_PAYMENT_STATISTICS_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default getPaymentStatisticsReducer
